import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";
import { BottomNavigation } from "../components/BottomNavigation";
import { VoiceControlBar } from "../components/ui/voice-control-bar";
import { VoiceSettingsModal } from "../components/ui/voice-settings-modal";
import { useVoice } from "../contexts/VoiceContext";
import { useGlobalKeyboard, type KeyboardShortcut } from "../hooks/useGlobalKeyboard";
import { useThemeManager } from "../hooks/useThemeManager";

export const Route = createFileRoute("/_layout")({
    component: LayoutComponent,
});

function LayoutComponent() {
    const [isVoiceSettingsOpen, setIsVoiceSettingsOpen] = useState(false);
    const { stop } = useVoice();
    const { toggleTheme } = useThemeManager();

    // Global keyboard shortcuts for app pages
    const shortcuts: KeyboardShortcut[] = [
        {
            key: "d",
            modifiers: ["shift", "ctrl", "alt"],
            action: toggleTheme,
            description: "Toggle light/dark theme",
        },
        // Future shortcuts can be easily added here:
        // { key: 's', modifiers: ['ctrl'], action: navigateToStoryMode, description: 'Go to story mode' },
        // { key: 'k', modifiers: ['ctrl'], action: openCommandPalette, description: 'Open command palette' },
    ];

    useGlobalKeyboard(shortcuts);

    // Scroll to top on route changes and stop speech
    const previousPathRef = useRef("");
    useEffect(() => {
        const currentPath = window.location.pathname;
        const previousPath = previousPathRef.current;

        if (currentPath !== previousPath) {
            window.scrollTo(0, 0);
            // Stop any active speech when navigating to a new page
            stop();
        }

        previousPathRef.current = currentPath;
    }, [stop]);

    return (
        <div className="text-foreground transition-colors">
            <Outlet />
            <BottomNavigation />
            <VoiceControlBar
                onOpenSettings={() => {
                    stop();
                    setIsVoiceSettingsOpen(true);
                }}
            />
            <VoiceSettingsModal isOpen={isVoiceSettingsOpen} onClose={() => setIsVoiceSettingsOpen(false)} />
        </div>
    );
}
